/* eslint-disable sort-keys-fix/sort-keys-fix */
export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1640,
};
